import React from "react";
import { BaseButton } from "./BaseButton";

export function PrimaryButton(props) {
	return (
		<BaseButton {...props} color={props.disabled ? "grey" : "blue"}>
			{props.children}
		</BaseButton>
	);
}
